module.exports = {
    title: 'indisigno',
    theme: {
        logoSource: '/assets/logo.svg'
    }
}
